import { trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { EmailTrigger } from 'src/app/enum/email.trigger';
import { Event } from 'src/app/model/event';
import { NO_PAGINATION } from 'src/app/model/pagination.options';
import { SelectOption } from 'src/app/model/select.option';
import { AdminService } from 'src/app/service/admin.service';
import { EventsService } from 'src/app/service/events.service';
import { NavbarService } from 'src/app/service/navbar.service';
import { EmailPreviewComponent } from '../email-preview/email-preview.component';
import { EmailTemplatePreviewComponent } from '../email-template-preview/email-template-preview.component';

export class TriggerData {
  id: number;
  name: string;
  trigger: string;
  import: boolean;
}

@Component({
  selector: 'app-import-email-templates-dialog',
  templateUrl: './import-email-templates-dialog.component.html',
  styleUrls: ['./import-email-templates-dialog.component.scss']
})
export class ImportEmailTemplatesDialogComponent implements OnInit {

  public availableEvents: Event[];
  public event: Event;
  public dataSource: MatTableDataSource<TriggerData>;
  
  public filterForm: FormGroup;
  public eventOptions: Array<SelectOption>;
  public triggerDataList: TriggerData[] =[]; 
  public triggersSelected: TriggerData[] =[]; 
  public columns = ['trigger', 'check'];
  public chosenEvent: number;

  constructor(  
    private eventsService: EventsService,
    private navbarService: NavbarService,
    private fb: FormBuilder,
    private adminService: AdminService,
    private dialogRef: MatDialogRef<ImportEmailTemplatesDialogComponent>,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.event = this.adminService.selectedEvent;
    this.getAvailableEvents();
    this.filterForm = this.fb.group({
      event: []
    });
  }

  public getAvailableEvents(){
    this.eventsService.getAllEventsWithMinimumDetails().subscribe(pagination => {
      this.eventOptions = pagination.filter(e => e.id !== this.event.id).map(event => ({ id: event.id, value: event.name }));
      this.navbarService.loadingStop();
    });
  }

  public getTriggersForEvent(eventId){
    this.chosenEvent=eventId;
    this.eventsService.getEventCoChairsNotification(eventId).subscribe(data => {
      // Filter to consider only triggers on the list
      // Map to format infos
      this.triggerDataList = data["triggers"].filter(t =>
        EmailTrigger.toIterable().includes(t["trigger"])
      ).map(trigger => ({
        id: trigger["id"],  
        name: EmailTrigger.getName(trigger["trigger"]),
        trigger: trigger["trigger"],
        import: true,
      }));
      // Initialize the triggers selected
      this.triggersSelected = this.triggerDataList;

      // Init table data source from the trigger datalist
      this.dataSource = new MatTableDataSource<TriggerData>(this.triggerDataList);
    });
  }

  public updateSelectionTrigger(itemId, event){
    const trigg = this.triggerDataList.find(trigger => trigger.id==itemId);
    if (trigg){
      trigg.import = event;
    }
    this.triggersSelected= this.triggerDataList.filter(trigger => trigger.import)
    console.log()
  }

  public previewTemplate(template){
    this.eventsService.getEventNotificationEmailbyEvent(template.trigger, this.chosenEvent)
      .subscribe(nf => {
        const dialogConfig = new MatDialogConfig();  
        dialogConfig.data={
          subject: nf.subject,
          content: nf.content
        };
        dialogConfig.autoFocus = false;
        dialogConfig.maxHeight = '90vh'; // prevents dialog from exceeding 90% of viewport 
        dialogConfig.panelClass = 'templates-dialog';
        const dialogRef = this.dialog.open(EmailTemplatePreviewComponent, dialogConfig);
      })
  }

  public confirmImport(){
    const data = {
      eventId: this.chosenEvent,
      triggerList: this.triggersSelected
    }
    this.dialogRef.close(data);
  }
}
